module.exports = __webpack_public_path__ + "static/screenshot-desktop3-de47b5676a332a2444da8c1a9660ff0e.png";